import React from "react";
import { ChevronDown } from "lucide-react";

export default function ActiveUserChip({ user, onClick }) {
  return (
    <button
      onClick={onClick}
      data-testid="active-user-chip"
      className="flex items-center gap-2 pl-1 pr-3 py-1 rounded-full bg-white/10 border border-white/15 backdrop-blur active:scale-95 transition"
    >
      {user ? (
        <>
          <div
            className="w-8 h-8 rounded-full flex items-center justify-center text-lg"
            style={{ background: user.color + "55" }}
          >
            {user.emoji}
          </div>
          <span className="text-sm font-semibold text-[#FAF8F3]">
            Fishing as <span className="font-black">{user.name}</span>
          </span>
        </>
      ) : (
        <span className="text-sm font-semibold text-[#FAF8F3] px-2">Pick angler</span>
      )}
      <ChevronDown className="w-4 h-4 text-[#FAF8F3]/60" strokeWidth={2.5} />
    </button>
  );
}
